<template>
	<div class="rating flex justify-between px-3 py-3 items-center rounded">
		<!-- <span class="font-semibold">{{ labels.helpfulquestion }}</span>
		<MessageToast /> -->
		<div class="ml-auto text-right flex">
			<!-- <button
				class="text-success-active inline-flex ml-2 mr-2 font-semibold active:underline"
				v-ripple
				type="button"
				severity="success"
				@click="showSuccess"
			>
				<i class="w-5 h-5 mr-1 tabler:message-star"></i>
				<span class="hidden md:block">{{ labels.veryhelpful }}</span>
			</button>
			<button
				class="inline-flex ml-2 mr-2 text-warning-active font-semibold focus:underline active:underline"
				type="button"
				severity="success"
				@click="showSuccess"
			>
				<i class="tabler:message-check w-5 h-5 mr-1"></i>

				<span class="hidden md:block">{{ labels.helpful }}</span>
			</button>
			<button
				class="inline-flex ml-2 font-semibold text-danger-active active:underline"
				type="button"
				severity="success"
				@click="showSuccess"
			>
				<i class="tabler:message-2-off w-5 h-5 mr-1"></i>
				<span class="hidden md:block">{{ labels.nothelpful }}</span>
			</button> -->
			<button
				class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white no-print"
				:class="{ 'rounded-e mr-2': !collectionModeData?.editmode }"
				type="button"
				v-if="!collectionModeData?.hidePostQuizButton"
				@click="$emit('open-postquiz')"
			>
				<i class="tabler:list-details w-5 h-5 mr-1"></i>
				<span class="hidden md:inline">{{ labels.postquiz }}</span>
			</button>
			<EditButton
				v-if="collectionModeData?.editmode && props.jsonData?._links.postQuiz?.href"
				class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
				:id="props.jsonData?.identifier ?? ''"
				:type="collectionModeData?.id === 'language_review' ? 'lngReviewEdit' : 'postquiz'"
				:overrideURL="props.jsonData?._links.postQuiz?.href"
			/>

			<EditButton
				class="rounded flex flex-row hover:bg-primary-500/80 items-center ml-2 py-2 px-3 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
				v-if="!collectionModeData?.hideFeedbackButton && AppConfig.urls.feedback?.url"
				:id="props.jsonData?.identifier" type="feedback"
				:buttonLabel="AppConfig.urls.feedback?.buttonLabel"
				:toolTipLabel="AppConfig.urls.feedback?.toolTipLabel"
				@click="console.log('Going to:', feedbackUrl)"
				:overrideURL="props.feedbackUrl" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { useToast } from 'primevue/usetoast';
import { messages } from '@/assets/language';
import type { configCollectionMode, LanguageCodes } from '@/types'
import EditButton from '../components/EditButton.vue';

import { useAppStore } from '@/stores/app-store'
import { useAppConfig } from '@/composables/useAppConfig';




const { currentLng } = useAppStore()

const AppConfig = useAppConfig();
const collectionModeData = ref<configCollectionMode | null>(null);

const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
});
//console.log('gjuha-ratings', currentLng.value)


const props = defineProps<{
	selectedLanguage?: LanguageCodes;
	modalVisiblePostQuiz: boolean;
	collectionMode?: configCollectionMode | null;
	jsonData: {
	  identifier:string;
      title?: string
	  _links: {
		postQuiz?: { href: string }
	  }
  	};
	feedbackUrl?: string
}>();


onMounted(() => {
	collectionModeData.value = props.collectionMode ?? null
	//console.log('collectionModeData Nga Ratings', collectionModeData.value)
});
const toast = useToast();
const showSuccess = () => {
	toast.add({
		severity: 'success',
		summary: 'Successful submission',
		detail: 'Thank you for your feedback!',
		life: 9000,
	});
};

</script>

<style scoped></style>
